import { render, staticRenderFns } from "./Nova-fatura.vue?vue&type=template&id=79163791&scoped=true&"
import script from "./Nova-fatura.vue?vue&type=script&lang=js&"
export * from "./Nova-fatura.vue?vue&type=script&lang=js&"
import style0 from "./Nova-fatura.vue?vue&type=style&index=0&id=79163791&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79163791",
  null
  
)

export default component.exports